import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=10164d72&scoped=true"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"
import style0 from "./HomeBanner.vue?vue&type=style&index=0&id=10164d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10164d72",
  null
  
)

export default component.exports